import React from 'react';
import Grid from '@material-ui/core/Grid';
import css from './PublicLayoutMobile.module.scss';
import LogoAndHeadingContainer from '../containers/Public/LogoAndHeadingContainer';
import Footer from '../containers/Public/Footer/FooterContainer';
import HeaderMobile from '../components/Public/Header/HeaderMobile';
import SponsorsTicker from '../components/Public/SponsorsTicker/SponsorsTicker';
import JWFooter from '../components/Public/JWFooter/JWFooter';
import PreviewToggle from '../components/Public/Floating/PreviewToggle';
import JWSubscriptionWidget from '../components/Public/JWSubscriptionWidget/JWSubscriptionWidget';
import { makeStyles } from '@material-ui/core';
import { WebsiteNotActive } from './usePublicLayoutDisabled';
import { homePath } from 'appDir/lib/constants/links';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  toggleContainer: {
    position: 'fixed',
    zIndex: 1100,
    top: 6,
    right: 8,
    '@media (min-width:0px) and (orientation: landscape)': {
      top: 2,
      right: 4,
    },
    '@media (min-width:600px)': {
      top: 10,
      right: 10,
    },
  },
});

const PublicLayoutMobile = props => {
  const classes = useStyles();
  // HOOKS END

  const {
    // homepage,
    $$sponsors,
    isEditingOrganization,
    canEditOrganization,
    $$organization,
    organizationBackgroundImage,
    viewDisabled,
  } = props;
  const { $$navbarItems, ...mobileProps } = props;
  const homepage = window?.location?.pathname === homePath;

  return (
    <div className={classes.root}>
      <HeaderMobile navbarItems={$$navbarItems} {...mobileProps} />
      <div
        className={css.mainMobile}
        style={{ backgroundImage: `url(${organizationBackgroundImage})` }}
      >
        <Grid container className={css.container}>
          <Grid item xs={12}>
            <JWSubscriptionWidget
              organization={$$organization}
              canEditOrganization={canEditOrganization}
            />
          </Grid>
          <Grid item xs={12}>
            <LogoAndHeadingContainer />
          </Grid>
        </Grid>
        <div className={css.container}>
          {viewDisabled ? <WebsiteNotActive /> : props.children}
        </div>
      </div>
      {!viewDisabled && (
        <React.Fragment>
          {homepage && (
            <SponsorsTicker
              isEditingOrganization={isEditingOrganization}
              sponsors={props.$$sponsors}
            />
          )}
          <Footer />
        </React.Fragment>
      )}
      <JWFooter
        canEditOrganization={canEditOrganization}
        isEditingOrganization={isEditingOrganization}
        organization={$$organization}
      />
      <div className={classes.toggleContainer}>
        <PreviewToggle />
      </div>
    </div>
  );
};

PublicLayoutMobile.propTypes = {};
PublicLayoutMobile.defaultProps = {};

export default PublicLayoutMobile;
